import styled from "@emotion/styled";

import { setFullViewportWidthStyles, theme } from "shared/lib/styles";

import { AppFooter } from "scmp-app/components/app-footer";
import { SignUpNewsletter } from "scmp-app/components/posties/brochure-homepage/sign-up-newsletter";

export const PageContainer = styled.div`
  ${setFullViewportWidthStyles()}
  margin-block-start: 32px;
  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 48px;
  }
`;

export const StyledSignUpNewsletter = styled(SignUpNewsletter)`
  position: relative;
  z-index: 1;
`;

export const StyledAppFooter = styled(AppFooter)`
  position: relative;

  margin-block-start: -150px;
  padding-block-start: 130px;

  background-color: #1b4191;
`;
